import type { RouteRecordRaw } from 'vue-router'

import ProfileView from '@/modules/profile/views/ProfileView.vue'
import OrdersView from '@/modules/profile/views/OrdersView.vue'
import OrderView from '@/modules/profile/views/OrderView.vue'
import FavoritesView from '@/modules/profile/views/FavoritesView.vue'

export const profileRoutes: RouteRecordRaw[] = [
  {
    path: '/profile',
    name: 'profile',
    component: ProfileView,
    meta: {
      title: 'Профиль',
      requiresAuth: true,
    },
  },
  {
    path: '/orders',
    name: 'orders',
    component: OrdersView,
    meta: {
      title: 'Мои заказы',
      requiresAuth: true,
      blockSupplier: true,
    },
  },
  {
    path: '/orders/:id',
    name: 'order',
    component: OrderView,
    meta: {
      title: 'Заказ',
      requiresAuth: true,
      blockSupplier: true,
    },
    props: true,
  },
  {
    path: '/favorites',
    name: 'favorites',
    component: FavoritesView,
    meta: {
      title: 'Избранное',
      requiresAuth: false,
    },
  },
]
